<template>
    <div class="p20">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">新建其他收付单</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15" ref="productCard"> 
            <ly-product-table 
                ref="productTable"
                :thead-config="productConfig"
                v-model="submitForm.productList">
                <div class="ly-product-total">
                    小计: {{totalAmount}}&nbsp;
                </div>
            </ly-product-table>
        </el-card>
        <!-- 商品选择组件 end -->
    </div>
</template>
<script>
    /**
     * 胎号的新增页面
     * @author zjs
     * @time 2017-09-18
     */
    import AddProductConfig from './add-product'
    import LyProductTable from '@c/product-table'
    import LyRouterButton from '@c/router-button'
    import AddRulesConfig from './rules'
    export default {
        mixins: [
            AddProductConfig,
            AddRulesConfig
        ],
        components: {
            LyProductTable,
            LyRouterButton
        },
        computed: {
            totalAmount () {
                let total = 0 
                let realtimeTotal_ = {}
                this.submitForm.productList.forEach(function (el, index, originalArr) {
                    if (!realtimeTotal_['realtimeTotal' + el.customer.customer_id]) { // 当前是否存在这个客户的实时余额总和属性
                        realtimeTotal_['realtimeTotal' + el.customer.customer_id] = parseFloat(el.wlye.amount) || 0
                    }
                    // 计算理赔总金额
                    if (el.amount && !isNaN(el.amount)) {
                        total = (parseFloat(total) + parseFloat(el.amount)).toFixed(2)
                    }
                    // 计算实时余额
                    let money = (parseFloat(el.amount || 0) + parseFloat(realtimeTotal_['realtimeTotal' + el.customer.customer_id])).toFixed(2)
                    if (!isNaN(money)) {
                        el.customer.ss_amount = money
                    } else {
                        el.customer.ss_amount = ''
                    }
                    realtimeTotal_['realtimeTotal' + el.customer.customer_id] = el.customer.ss_amount
                }, this)
                return total
            }
        },
        data () {
            return {
                submitLoad: false, // 提交按钮的状态标识
                submitForm: {
                    uuid: '',
                    productList: []
                } // 提交的表单数据
            }
        },
        watch: {
            '$route' (to, from) {
                // 清空之前的输入
                if (to.name === 'PaymentOtherpayAdd') {
                    this.$refs['productTable'].resetList()
                }
            }
        },
        mounted () {
            // 设置UUID
            this.submitForm.uuid = this.$utils.createUUID()
        },
        methods: {
            submit () {
                let productList = this.$refs['productTable'].getProductData()
                if (productList && productList.length > 0) {
                    // 货品验证
                    let productMsg = this.validateProduct(productList)
                    // 货品验证不通过的情况
                    if (productMsg.length > 0) {
                        this.$alert(productMsg, '货品录入提示', {
                            confirmButtonText: '确定'
                        })
                    } else {
                        this.submitLoad = true
                        this.submitForm['data'] = productList
                        // 提交数据
                        this.$api.create('api/qitasf', this.submitForm).then((rs) => {
                            this.$alert('数据提交成功', '新增', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.submitLoad = false
                                    // 跳转到详情页面
                                    this.$router.push('/bill/qitasf/info/' + rs.id)
                                }
                            })
                            // 更新UUID
                            this.submitForm.uuid = this.$utils.createUUID()
                        }).catch((error) => {
                            this.submitLoad = false
                            this.$message({
                                message: error,
                                type: 'warning'
                            })
                        })
                    }
                } else {
                    this.$message({
                        message: '请选择货品',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>